import { Owner as GraphqlOwner } from 'vvs-gotchi-graphql'

import { Mole, LockedMole, moleFromGraphqlData, lockedMoleFromGraphqlData } from './mole'
import { MoleDashInfo, moleDashInfoFromGraphqlData } from '../quests/moleDash'

export type Owner = {
  address: string
  moles: Array<Mole>
  lockedMoles: Array<LockedMole>
  hasAdopted?: boolean
  isOnboarded?: boolean
  teamHealthPoint?: number
  expMultiplier: number
  isClean?: boolean
  nextDirtyDeclineTime?: string
  highestDayExp?: number
  todayExp?: number
  todayQuestCount?: number
  totalQuestCount?: number
  totalEarnedExp?: number
  gachaInfo: {
    isTeamFedToday?: boolean
    isGachaEligible?: boolean
    gachaRecordCount?: number
    todayDifferentQuestCount?: number
  }
  moleDashInfo: MoleDashInfo
}

export const ownerFromGraphqlData = (
  data: Omit<GraphqlOwner, 'questHistory'> & {
    questHistory?: {
      questHistoryConnection?: {
        totalCount: GraphqlOwner['questHistory']['questHistoryConnection']['totalCount']
      }
      totalEarnedExp?: GraphqlOwner['questHistory']['totalEarnedExp']
    }
  },
): Omit<Owner, 'questHistory'> => {
  return {
    address: data.address,
    moles: data.moles ? data.moles.map(moleFromGraphqlData) : [],
    lockedMoles: data.lockedMoles ? data.lockedMoles.map(lockedMoleFromGraphqlData) : [],
    hasAdopted: data.hasAdopted ?? false,
    isOnboarded: data.isOnboarded,
    teamHealthPoint: data.teamHealthPoint,
    expMultiplier: data.expMultiplier ?? 1,
    isClean: data?.isClean ?? true,
    nextDirtyDeclineTime: data?.nextDirtyDeclineTime,
    highestDayExp: data.highestDailyExp,
    todayExp: data.todayExp,
    todayQuestCount: data.todayQuestCount,
    totalQuestCount: data.questHistory?.questHistoryConnection?.totalCount,
    totalEarnedExp: data.questHistory?.totalEarnedExp,
    gachaInfo: data.gachaInfo,
    moleDashInfo: moleDashInfoFromGraphqlData(data?.moleDashInfo),
  }
}
